// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TWebCreateSavedSearchRequest,
  TWebCreateSavedSearchModel,
  IMappers,
  TWebCreateSavedSearchResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { ICreateSavedSearchWebPublicResponseSchema } from '../../../entities/create_saved_search/CreateSavedSearchWebPublicResponseSchema';
import type { IErrorResponseSchema } from '../../../entities/schemas/ErrorResponseSchema';

export function createWebCreateSavedSearchModel(parameters: TWebCreateSavedSearchRequest): TWebCreateSavedSearchModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'saved-searches',
    pathApi: '/v1/web/create-saved-search/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IWebCreateSavedSearchOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TWebCreateSavedSearchRequest;
}

export async function fetchWebCreateSavedSearch<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IWebCreateSavedSearchOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TWebCreateSavedSearchResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createWebCreateSavedSearchModel(parameters),
    config,
  )) as FetchResponse<TWebCreateSavedSearchResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as ICreateSavedSearchWebPublicResponseSchema, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TWebCreateSavedSearchResponse>;
}
